// Mobile sticky "Aggiungi al carrello" bar (snippets/sticky-add-to-cart.liquid).
// Shows while the product form's submit button is off screen and forwards taps to it,
// mirroring its disabled/loading state and label.
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.source = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.source || !this.button) return;

        this.button.addEventListener('click', () => this.source.click());

        this.syncButton();
        this.sourceObserver = new MutationObserver(() => this.syncButton());
        this.sourceObserver.observe(this.source, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.visibilityObserver = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));
        this.visibilityObserver.observe(this.source);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.sectionId) return;
          const id = `StickyAtcInfo-${this.sectionId}`;
          const next = data.html.getElementById(id);
          const current = document.getElementById(id);
          if (next && current) current.innerHTML = next.innerHTML;
        });
      }

      disconnectedCallback() {
        this.sourceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.toggle(false);
      }

      toggle(visible) {
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        document.body.classList.toggle('sticky-atc-visible', visible);
      }

      syncButton() {
        const loading = this.source.classList.contains('loading');
        this.button.disabled = this.source.disabled;
        this.button.classList.toggle('loading', loading);
        this.button.toggleAttribute('aria-disabled', loading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        this.button.querySelector('span').textContent = this.source.querySelector('span').textContent.trim();
      }
    }
  );
}
